<dx-drop-down-button [splitButton]="true"
                     [disabled]="recentRequisitions.length === 0"
                     [useSelectMode]="false"
                     [dropDownOptions]="{ width: 1000 }"
                     [text]="'Previous Requisition'"
                     [icon]="'fa fa-arrow-left'"
                     (onButtonClick)="lastRequisitionBtnClicked()"
                     [dropDownContentTemplate]='"recentList"'
>
    <div *dxTemplate="let data of 'recentList'" style="width: 1000px">
        <dx-data-grid height="100%" width="100%" [dataSource]="recentRequisitions" [showBorders]="true" [wordWrapEnabled]="true" (onRowClick)="rowClick($event)"
                      [hoverStateEnabled]="true">
            <dxi-column caption="Requisition Id" dataField="codeValue" width="100px"></dxi-column>
            <dxi-column caption="Last Name" dataField="lastName" width="150px"></dxi-column>
            <dxi-column caption="First Name" dataField="firstName" width="150px"></dxi-column>
            <dxi-column caption="Birth Date" dataField="birthDate" width="80px" dataType="date"></dxi-column>
            <dxi-column caption="Client Name" dataField="clientName" width="200px"></dxi-column>
            <dxi-column caption="Tests" dataField="tests"></dxi-column>
        </dx-data-grid>
    </div>
</dx-drop-down-button>
